import { find, toInteger } from 'lodash';
import { decodeTranformCode } from '../TransformsUtils';

const NEXLA_CUSTOM_TRANSFORM = { operation: 'nexla.custom' };

/** removes all the JS and Python comments from the code to avoid unnecessary regex matches. */
function stripCommentsFromCustomCodeLine(line) {
  const withoutPythonComment = line.replace(/#.*$/, '');
  const withoutJsComment = withoutPythonComment.replace(/\/\/.*$/, '');
  return withoutJsComment;
}

/** `idCaptureIndex` is the `RegExpMatchArray` index of the numeric ID capture group. */
export function getIntegerIdsFromNexlaCustomCode(payload, nexlaFnCallRegex, idCaptureIndex) {
  const transforms = payload?.transform?.transforms;
  const spec = find(transforms, NEXLA_CUSTOM_TRANSFORM)?.spec;

  if (!spec) return [];

  const code = decodeTranformCode(spec.script, spec.encoding);
  const cleanedCode = code.split('\n').map(stripCommentsFromCustomCodeLine).join('\n');

  const callMatches = cleanedCode.matchAll(nexlaFnCallRegex);

  return Array.from(callMatches).map((regexMatch) => {
    const idString = regexMatch[idCaptureIndex];
    return toInteger(idString);
  });
}
